import { render, staticRenderFns } from "./UserDetailsEditUserModal.vue?vue&type=template&id=59edf4ee"
import script from "./UserDetailsEditUserModal.vue.ts?vue&type=script&lang=ts&external"
export * from "./UserDetailsEditUserModal.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports